module.exports = __webpack_public_path__ + "assets/d70635c479328b265db6673272c44ba0.eot";